import type { MenuOption, MenuSection } from './menu';

const MAX_PINNED = 3;

// The pinned mobile tabs: every item that declares an `importance`, deduped by
// name across sections, ordered by importance ascending (0 = highest) then name,
// capped at `limit`. Items without an importance are never pinned.
export const getPinnedMenuItems = (
  sections: MenuSection[],
  limit: number = MAX_PINNED
): MenuOption[] => {
  const seen = new Set<string>();
  const flattened: MenuOption[] = [];

  sections.forEach(section => {
    section.items.forEach(item => {
      if (!seen.has(item.name)) {
        seen.add(item.name);
        flattened.push(item);
      }
    });
  });

  return flattened
    .filter(item => item.importance !== undefined)
    .sort((a, b) => {
      const byImportance = (a.importance as number) - (b.importance as number);
      return byImportance !== 0 ? byImportance : a.name.localeCompare(b.name);
    })
    .slice(0, limit);
};

// The "More" sheet content: the same sections with the pinned items removed and
// any section left empty dropped, preserving the original order and headings.
export const getSheetSections = (sections: MenuSection[], pinned: MenuOption[]): MenuSection[] => {
  const pinnedNames = new Set(pinned.map(item => item.name));

  return sections
    .map(section => ({
      ...section,
      items: section.items.filter(item => !pinnedNames.has(item.name)),
    }))
    .filter(section => section.items.length > 0);
};
